import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Search from "./Search.jsx";
import { DealerContextProvider } from "../../contexts/DealerContext.jsx";
import ResultsContainer from "./ResultsContainer.jsx";

const DealerLocator = ({basePath, apiKey}) => {

  return (
    <div className="ft_dealer-locator">
      <Router basename={basePath}>
        <DealerContextProvider apiKey={apiKey}>
          <Switch>
            <Route path='/search' component={ResultsContainer} />
            <Route index component={Search} />
          </Switch>
        </DealerContextProvider>
      </Router>
    </div>
  );

}

export default DealerLocator;
